import type { Vector2 } from 'three';

/**
 * Test whether `point` lies within `tolerance` units of the circle of given
 * `center` and `radius`. Used for resize-handle hit-testing on the femur head
 * dotted circle. Tolerance is one-sided (full band width is `2 * tolerance`).
 */
export function isPointOnCircleEdge(
    point: Vector2,
    center: Vector2,
    radius: number,
    tolerance: number,
): boolean {
    const distance = point.distanceTo(center);
    return Math.abs(distance - radius) <= tolerance;
}
